// import { useState, useEffect } from "react";
// import "./manageinvoice.css";
// import Table from "react-bootstrap/Table";
// import Axios from "axios";

// function Manageinvoice() {
//   const [data, setData] = useState([]);
//   const [totalAmount, setTotalAmount] = useState(0);
//    const [totalGST, setTotalGST] = useState(0);

//   const [totalAmountWithGST, setTotalAmountWithGST] = useState(0);


//   useEffect(() => {
//     Axios.get("http://13.200.156.92:5000/getVendor").then((response) => {
//       setData(response.data);

//       const totalAmountCalculation = response.data.reduce((acc, row) => {
//         const rowTotalAmount = row.Entries.reduce(
//           (entryAcc, entry) => entryAcc + entry.amount,
//           0
//         );
//         return acc + rowTotalAmount;
//       }, 0);

//       setTotalAmount(totalAmountCalculation);

//       const totalGSTCalculation = response.data.reduce((acc, row) => {
//         const rowTotalGST = row.Entries.reduce(
//           (entryAcc, entry) => entryAcc + entry.gstvalue,
//           0
//         );
//         return acc + rowTotalGST;
//       }, 0);

//       setTotalGST(totalGSTCalculation);

//       const totalAmountWithGSTCalculation = response.data.reduce((acc, row) => {
//         const rowTotalAmountWithGST = row.Entries.reduce(
//           (entryAcc, entry) => entryAcc + entry.totalAmountWithGST,
//           0
//         );
//         return acc + rowTotalAmountWithGST;
//       }, 0);

//       setTotalAmountWithGST(totalAmountWithGSTCalculation);
//     });
//   }, [data]);

//   const handleDelete = async (id) => {
//     const confirmed = window.confirm("Are you sure you want to delete?");
//     window.location.reload();

//     if (confirmed) {
//       try {
//         await Axios.delete(`http://13.200.156.92:5000/veninvoicedelete/${id}`);
//       } catch (error) {
//         console.error(error);
//       }
//       window.location.reload();
//     }
//   };

//   return (
//     <div>
//       <label className="manageveninvoice">
//         <h5>Manage Invoice</h5>
//       </label>
//       <br />
     
//          <br />
     
//       <br />
      
//       <Table bordered hover responsive size="sm" className="manageinvtab">
//         <thead>
//           <tr>
//             <th>Order ID</th>
//             <th>Challan No</th>
//             <th>Invoice No</th>
//             <th>Title</th>
//             <th>Medium</th>
//             <th>Edition</th>
//             <th>SKU</th>

//             <th>Order Quantity</th>
//             <th>Printed Quantity</th>
//             <th>Printing Price</th>
//             <th>Amount</th>
//             <th>GST(%)</th>
//          <th>GST Value</th>
//             <th>Amount + GST Values</th>
//             <th>Action</th>
//           </tr>
//         </thead>
//         <br />
//         <tbody>
//           {data.map((row, index) => {
//             return row.Entries.map((entry, entryIndex) => (
//               <tr key={`${row.orderid}-${entryIndex}`}>
//                 {entryIndex === 0 ? <td>{row.orderid}</td> : <td></td>}
//                 {entryIndex === 0 ? <td>{row.challanno}</td> : <td></td>}
//                 {entryIndex === 0 ? <td>{row.invoiceno}</td> : <td></td>}
//                 <td>{entry.Title}</td>
//                 <td>{entry.Medium}</td>
//                 <td>{entry.Edition}</td>
//                 <td>{entry.SKU}</td>

//                 <td>{entry.orderquantity}</td>
//                 <td>{entry.printquantity}</td>
//                 <td>{entry.printprice}</td>

//                 <td>{entry.amount}</td>

//                 <td>{entry.gst}%</td>
//                    <td>{entry.GstValue}</td>

//                 <td>{entry.totalAmountWithGST}</td>

//                 <td>
//                   {entryIndex === 0 && (
//                     <button
//                       type="button"
//                       className="btn btn-danger"
//                       id="delete"
//                       onClick={() => handleDelete(row._id)}
//                     >
//                       Delete
//                     </button>
//                   )}
//                 </td>
//               </tr>
//             ));
//           })}
//         </tbody>
//       </Table>
//       <br />
//       {/* {data.map((row, index) => (
//         <div key={index}>
//           <label className="chalnodata">Challan Number: {row.challanno}</label>
//           <br />
//           <label className="chalnodata">Invoice Number: {row.invoiceno}</label>
//         </div>
//       ))} */}
//       <br />
//     </div>
//   );
// }

// export default Manageinvoice;


import { useState, useEffect } from "react";
import "./manageinvoice.css";
import Table from "react-bootstrap/Table";
import Axios from "axios";

function Manageinvoice() {
  const [data, setData] = useState([]);
  const [totalAmount, setTotalAmount] = useState(0);
  const [totalGST, setTotalGST] = useState(0);
  const [totalAmountWithGST, setTotalAmountWithGST] = useState(0);

  useEffect(() => {
    Axios.get("https://nodei.ssccglpinnacle.com/getVendor").then((response) => {
      setData(response.data);

      const totalAmountCalculation = response.data.reduce((acc, row) => {
        const rowTotalAmount = row.Entries.reduce(
          (entryAcc, entry) => entryAcc + entry.amount,
          0     );
        return acc + rowTotalAmount;
      }, 0);

      setTotalAmount(totalAmountCalculation);

      const totalGSTCalculation = response.data.reduce((acc, row) => {
        const rowTotalGST = row.Entries.reduce(
          (entryAcc, entry) => entryAcc + entry.GstValue ,
          0     );
        return acc + rowTotalGST;
      }, 0);

      setTotalGST(totalGSTCalculation);

      const totalAmountWithGSTCalculation = response.data.reduce((acc, row) => {
        const rowTotalAmountWithGST = row.Entries.reduce(
          (entryAcc, entry) => entryAcc + entry.totalAmountWithGST,
          0
        );
        return acc + rowTotalAmountWithGST;
      }, 0);

      setTotalAmountWithGST(totalAmountWithGSTCalculation);
    });
  }, [data]);

  const handleDelete = async (id) => {
    const confirmed = window.confirm("Are you sure you want to delete?");
    window.location.reload();

    if (confirmed) {
      try {
        await Axios.delete(`https://nodei.ssccglpinnacle.com/veninvoicedelete/${id}`);
      } catch (error) {
        console.error(error);
      }
      window.location.reload();
    }
  };

  return (
    <div>
      <label className="manageveninvoice">
        <h5>Manage Invoice</h5>
      </label>
      <br />
      <div className="manageamount">
       Total Amount + GST  Order ID Wise: {totalAmountWithGST.toFixed(2)}
      </div>
         <br />
      <div className="manageamount">
        Total GST Paid : {totalGST.toFixed(2)}
      </div>
      <br />
      
      <Table bordered hover responsive size="sm" className="manageinvtab">
        <thead>
          <tr>
            <th>Order ID</th>
            <th>Challan Nos</th>
            <th>Invoice No</th>
            <th>Title</th>
            <th>Medium</th>
            <th>Edition</th>
            <th>SKU</th>
            <th>Order Quantity</th>
            <th>Printed Quantity</th>
            <th>Printing Price</th>
            <th>Amount</th>
            <th>GST(%)</th>
            <th>GST Value</th>
            <th>Amount + GST Values</th>
            <th>View Invoice</th>
            <th>Action</th>
          </tr>
        </thead>
        <br />
        <tbody>
          {data.map((row, index) => {
            return row.Entries.map((entry, entryIndex) => (
              <tr key={`${row.orderid}-${entryIndex}`}>
                {entryIndex === 0 ? <td>{row.orderid}</td> : <td></td>}
                {entryIndex === 0 ? <td>{row.challanno}</td> : <td></td>}
                {entryIndex === 0 ? <td>{row.invoiceno}</td> : <td></td>}
                <td>{entry.Title}</td>
                <td>{entry.Medium}</td>
                <td>{entry.Edition}</td>
                <td>{entry.SKU}</td>
                <td>{entry.orderquantity}</td>
                <td>{entry.printquantity}</td>
                <td>{entry.printprice}</td>
                <td>{entry.amount}</td>
                <td>{entry.gst}%</td>
               <td>{entry.GstValue}</td>
               <td>{entry.totalAmountWithGST}</td>
         { entryIndex === 0 &&  <td>
                        {row.InvFile ? (
                          row.InvFile.endsWith(".pdf") ? (
                            <a
                              href={`http://13.200.156.92:5000/${row.InvFile}`}
                              download={row.InvFile}
                            >
                              Open PDF
                            </a>
                          ) : (
                            <a
                              href={`http://13.200.156.92:5000/${row.InvFile}`}
                              download={row.InvFile}
                            >
                              Open Image
                            </a>
                          )
                        ) : (
                          <p>Not Uploaded</p>
                        )}
                      </td>}
               <td>
                  {entryIndex === 0 && (
                    <button
                      type="button"
                      className="btn btn-danger"
                      id="delete"
                      onClick={() => handleDelete(row._id)}
                    >
                      Delete
                    </button>
                  )}
                </td>
              </tr>
            ));
          })}
        </tbody>
      </Table>
      <br />
      <br />
    </div>
  );
}

export default Manageinvoice;

